/** @owner @Appboy/ai-decisioning-experience */

import { isDecisioningStudioCampaign } from "./isDecisioningStudioCampaign";
import type { DecisioningStudioCampaignContext } from "./types";

/**
 * @param messagesContext - The current messages context, if any
 * @return Liquid options to pass as `additionalOptions` for DS-linked campaign composers
 */
export const getDecisioningStudioLiquidAdditionalOptions = (
  messagesContext: DecisioningStudioCampaignContext | null | undefined
): "DECISIONING_CREATIVE_COMPONENT"[] => {
  if (isDecisioningStudioCampaign(messagesContext)) {
    return ["DECISIONING_CREATIVE_COMPONENT"];
  }
  return [];
};
